<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/corporate/campaign-event-builder">Campaign Event Builder</a>
            </li>
            <li class="breadcrumb-item"><a routerLink="/corporate/campaign-event-list">Events</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{headers}} Campaign Event</li>

        </ol>
    </nav>
</div>
<div class="container">
    <form class="form-horizontal mt-1" [formGroup]="eventForm">
        <div class="row">
            <div class="col-md-10 col-xl-7">
                <div class="card mt-1">
                    <div class="card-body">
                        <div class="form-group">
                            <label for="exampleForm2">Select Company Name<span style="color:red">*</span></label>
                            <select formControlName="company" class="form-control formstyle"
                                [ngClass]="{ 'is-invalid': submitted && f.company.errors }">
                                <option value="">Select Company Name</option>
                                <option *ngFor="let userObj of getCompanyobj" value={{userObj.customer_id}}>
                                    {{userObj.customer_company_name}}
                                </option>
                            </select>
                            <div *ngIf="submitted && f.company.errors" class="invalid-feedback">
                                <div *ngIf="f.company.errors.required">Company Name is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="exampleForm2">Event Type<span style="color:red">*</span></label>
                            <select formControlName="eventType" name="event_type" class="form-control formstyle"
                                [ngClass]="{ 'is-invalid': submitted && f.eventType.errors }">
                                <option value="">select event type</option>
                                <option value="1">Type 1</option>
                                <option value="2">Type 2</option>
                                <option value="3">Type 3</option>
                                <option value="4">Type 4</option>
                                <option value="5">Type 5</option>
                            </select>
                            <div *ngIf="submitted && f.eventType.errors" class="invalid-feedback">
                                <div *ngIf="f.eventType.errors.required">Event type is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="exampleForm2">Event Title<span style="color:red">*</span></label>
                            <input type="text" formControlName="eventTitle" min="1" maxlength="199"
                                class="form-control form-control-md"
                                [ngClass]="{ 'is-invalid': submitted && f.eventTitle.errors }" required appSpace>
                            <div *ngIf="submitted && f.eventTitle.errors" class="invalid-feedback">
                                <div *ngIf="f.eventTitle.errors.required">Event Title is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-center">
                        <div class="my_class text-center">
                            <button type="button" class="custbtn" *ngIf="isWrite && headers == 'Add'"
                                (click)="onAdd()">Submit</button>
                        </div>
                        <div class="my_class text-center">
                            <button type="button" class="custbtn" *ngIf="isEdit && headers == 'Edit'"
                                (click)="onUpdate()">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>